import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/user";
import header from "@/store/header";
import search from "@/store/search";
import sales from "@/store/sales";
import settings from "@/store/settings";
import discover from "@/store/discover";
import plans from "@/store/plans";
import layout from "@/store/layout";
import onboarding from "@/store/onboarding";
import teamsSettings from "@/store/teams-settings";
import multiUserPlanManagement from "@/store/multi-user-plan-management";
import business from "@/store/business";
import reader from "@/store/reader";
import toaster from "@/store/toaster";
import checkout from "@/store/checkout";
import content from "@/store/content";
import globals from "@/utils/globals";

if (globals.store) {
  throw new Error("A store is already defined");
}

Vue.use(Vuex);

export const modules = {
  user,
  header,
  search,
  sales,
  settings,
  discover,
  plans,
  onboarding,
  teamsSettings,
  multiUserPlanManagement,
  business,
  reader,
  toaster,
  layout,
  content,
  checkout
};

const store = new Vuex.Store({ modules });

globals.store = store;

export default store;
